/**
 * @generated SignedSource<<6a27a790e97ad713eacc91c6c629c25d>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type CreditApplicationPageType =
  | 'ADDRESS_CHALLENGE_ENTRY'
  | 'ADVERSE_ACTION_NOTICE'
  | 'APPLICATION_REVIEW_NOTICE'
  | 'CARD_ON_HOLD_NOTICE'
  | 'CREDIT_FREEZE_PROMPT'
  | 'DOWNLOAD_APP_NOTICE'
  | 'ELIGIBILITY_PASSED_PROMPT'
  | 'FINAL_TERMS_PROMPT'
  | 'FRAUD_ALERT_MANUAL_REVIEW_PROMPT'
  | 'FRAUD_ALERT_PHONE_PROMPT'
  | 'IDENTITY_CONTEST_ENTRY'
  | 'LIMIT_REVEAL_PROMPT'
  | 'PLAID_CONNECTION_PROMPT'
  | 'RUN_ELIGIBILITY_PROMPT'
  | 'SHIPPING_ADDRESS_ENTRY'
  | 'SOLID_GOLD_DELAY_PROMPT'
  | 'SSN_VERIFICATION_PROMPT'
  | 'SSN_VERIFIED_PROMPT'
  | 'TRACK_SHIPMENT_PROMPT'
  | 'UNKNOWN_ERROR_NOTICE'
  | '%future added value';
export type CreditApplicationPageRequest = {
  creditApplicationId: string;
  currPage?: CreditApplicationPageType | null;
};
export type NavigationProviderCreditApplicationPageQuery$variables = {
  q: CreditApplicationPageRequest;
};
export type NavigationProviderCreditApplicationPageQuery$data = {
  readonly creditApplicationPage: {
    readonly page: CreditApplicationPageType;
  };
};
export type NavigationProviderCreditApplicationPageQuery = {
  response: NavigationProviderCreditApplicationPageQuery$data;
  variables: NavigationProviderCreditApplicationPageQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'q',
            variableName: 'q',
          },
        ],
        concreteType: 'CreditApplicationPageResponse',
        kind: 'LinkedField',
        name: 'creditApplicationPage',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'page',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'NavigationProviderCreditApplicationPageQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'NavigationProviderCreditApplicationPageQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '49e07bc7c1a91b63ffffcb230a528413',
      id: null,
      metadata: {},
      name: 'NavigationProviderCreditApplicationPageQuery',
      operationKind: 'query',
      text: 'query NavigationProviderCreditApplicationPageQuery(\n  $q: CreditApplicationPageRequest!\n) {\n  creditApplicationPage(q: $q) {\n    page\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'd18c0734819c3a768a68cb8dca0b3276';

export default node;
